export const SYSTEM_ACTION_TYPES = {
    SET_SYSTEM_MODE: 'system/SET_SYSTEM_MODE',
    SET_EXPERIENCE_WAS_STARTED: 'system/SET_EXPERIENCE_WAS_STARTED',
    SET_USER_SIZE: 'system/SET_USER_SIZE'
};